import * as React from 'react';
import './ProductPickUpModal.scss';
import { isMobile } from 'src/utils/responsiveHelpers';
import SlideMenu from '../SlideMenu/SlideMenu';
import Modal from '../Modal/Modal';
import PickUpDeliverAddressChange from 'src/components/PickUpDeliverAddressChange';
import i18n from 'src/translation/i18n';

interface IProductPickUpModalprops {
  show: boolean;
  onClose: () => void;

  defaultWarehouse: any;
  supplierQuantity: number;
  selectedPickUp: string;
  deliverAddressesList: any[];

  handleChangePickUp: (pickUpAddress: string) => void;
}

interface IProductPickUpModalState {
  isMobile: boolean;
}

class ProductPickUpModal extends React.Component<
  IProductPickUpModalprops,
  IProductPickUpModalState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile()
    };
  }

  private renderDeliverAddressChange = () => {
    return (
      <PickUpDeliverAddressChange
        defaultWarehouse={this.props.defaultWarehouse}
        supplierQuantity={this.props.supplierQuantity}
        deliverAddresses={this.props.deliverAddressesList}
        handleClose={this.props.onClose}
        handleChangeAddress={this.props.handleChangePickUp}
        selectedPickup={this.props.selectedPickUp}
      />
    );
  };

  public componentDidMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public render() {
    return this.state.isMobile ? (
      <SlideMenu
        mounted={this.props.show}
        goBackTitle={i18n.t('common.back')}
        level={2 + 30}
        handleCloseMenu={this.props.onClose}
      >
        {this.renderDeliverAddressChange()}
      </SlideMenu>
    ) : (
      this.props.show && (
        <Modal handleCloseModal={this.props.onClose}>
          {this.renderDeliverAddressChange()}
        </Modal>
      )
    );
  }
}

export default ProductPickUpModal;
